var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFraud = function SvgFraud(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 26.5938C22.8578 26.5938 22.7189 26.6359 22.6007 26.7149C22.4825 26.7939 22.3904 26.9061 22.336 27.0374C22.2816 27.1688 22.2673 27.3133 22.2951 27.4527C22.3228 27.5921 22.3912 27.7202 22.4918 27.8207C22.5923 27.9213 22.7204 27.9897 22.8598 28.0174C22.9992 28.0452 23.1437 28.0309 23.2751 27.9765C23.4064 27.9221 23.5186 27.83 23.5976 27.7118C23.6766 27.5936 23.7187 27.4547 23.7187 27.3125C23.719 27.218 23.7006 27.1245 23.6646 27.0371C23.6285 26.9498 23.5756 26.8705 23.5088 26.8037C23.442 26.7369 23.3627 26.684 23.2754 26.6479C23.188 26.6119 23.0945 26.5935 23 26.5938Z",
    fill: "#0258FF",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 18.6875V14.375C30.1824 12.4703 29.4236 10.6451 28.0767 9.29826C26.7299 7.95144 24.9047 7.19256 23 7.1875V7.1875C21.0955 7.19306 19.2705 7.9521 17.9238 9.29881C16.5771 10.6455 15.8181 12.4705 15.8125 14.375V18.6875",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 7.1875V4.3125C1.4375 3.55 1.7404 2.81874 2.27957 2.27957C2.81874 1.7404 3.55 1.4375 4.3125 1.4375H7.1875",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5625 7.1875V4.3125C44.5625 3.55 44.2596 2.81874 43.7204 2.27957C43.1813 1.7404 42.45 1.4375 41.6875 1.4375H38.8125",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 38.8125V41.6875C1.4375 42.45 1.7404 43.1813 2.27957 43.7204C2.81874 44.2596 3.55 44.5625 4.3125 44.5625H7.1875",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5625 38.8125V41.6875C44.5625 42.45 44.2596 43.1813 43.7204 43.7204C43.1813 44.2596 42.45 44.5625 41.6875 44.5625H38.8125",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 18.6875H15.8125C14.2247 18.6875 12.9375 19.9747 12.9375 21.5625V33.0625C12.9375 34.6503 14.2247 35.9375 15.8125 35.9375H30.1875C31.7753 35.9375 33.0625 34.6503 33.0625 33.0625V21.5625C33.0625 19.9747 31.7753 18.6875 30.1875 18.6875Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFraud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fraud.3be8f7de.svg";
export { ForwardRef as ReactComponent };